import { ReactNode } from 'react';
import { confirm } from 'components/atoms/modal';

interface Content {
  title: ReactNode | string;
  content?: ReactNode | string;
  ok: string;
  cancel: string;
}
type ShowConfirmType = (content: Content, onConfirm: () => void) => void;

// More of a util function than an atom.  But returns a react component for confirmation
export const showConfirmPopup: ShowConfirmType = (
  { title, content = '', ok, cancel },
  onConfirm,
) => {
  confirm({
    title,
    content,
    okText: ok,
    cancelText: cancel,
    onOk: onConfirm,
  });
};
